// Shared color palette + conversion helpers used by Tools and Picker.
// Keep ES5-compatible (no optional chaining etc.) for Tizen TVs.

export const PALETTE = [
    // Row 1: Neutrals (light → dark)
    '#ffffff', '#c8c8c8', '#888888', '#444444', '#000000',
    // Row 2: Reds, pink, skin
    '#ffc0cb', '#ff5c8a', '#e63946', '#8b0000', '#ffcba4',
    // Row 3: Yellow → orange → brown
    '#fff275', '#ffd700', '#ff8c00', '#8b4513', '#4b2a0f',
    // Row 4: Greens, blues, purple
    '#b5e48c', '#1b5e20', '#2196f3', '#0d47a1', '#9c27b0',
];

export function rgbaToHex(rgba) {
    if (!rgba) return '#000000';
    if (rgba.startsWith('#')) return rgba;
    const m = rgba.match(/[\d.]+/g);
    if (!m || m.length < 3) return '#000000';
    const r = parseInt(m[0]), g = parseInt(m[1]), b = parseInt(m[2]);
    return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
}

export function hexToRgba(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},1)`;
}

// Picker uses an object form compatible with react-color's ChromePicker.
export function hexToColorObj(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { rgb: { r, g, b, a: alpha !== undefined ? alpha : 1 } };
}

export function rgbaAlpha(rgba) {
    if (!rgba) return 1;
    var m = rgba.match(/[\d.]+/g);
    if (!m || m.length < 4) return 1;
    return parseFloat(m[3]);
}
